// HANDLES SERVICE WORKER REGISTRATION
// In production, we register a service worker to serve assets from local cache.
//
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
//
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
import { INFO } from '../util/object'


// src: https://codesandbox.io/s/fcy42
const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||  // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// MAIN ENTRY: Call from TOP LEVEL /index.js
//
export default function register() {
    console.log("REG-SVC-WRKR.22.1: REGISTER SERVICE WORKER START....env=",process.env.NODE_ENV);

    //if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    if ("serviceWorker" in navigator) {
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location); // URL constructor available in all browsers support SvcW
        console.log("REG-SVC-WRKR.28: Check URL   url=", publicUrl.origin);     // process.env.PUBLIC_URL);

        if (publicUrl.origin !== window.location.origin) {
            console.log("REG-SVC-WRKR.26: URL domain mismatch, service worker won't work!");
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
            console.log("REG-SVC-WRKR.26: URL domain mismatch, service worker won't work!");
            return;
        }

        window.addEventListener("load", loadEvent);
        //window.addEventListener("install", installEvent);
        //window.addEventListener("activate", activateEvent);

    } else {
        console.log("REG-SVC-WRKR.45: Not Production, Service worker not started....");
    }
} 

const loadEvent = (loadEvent) => {
    const swUrl = `${process.env.PUBLIC_URL}/custom-service-worker.js`;
    //console.log("REG-SVC-WRKR.50: Load Event Handler  url=", window.location.origin);     // process.env.PUBLIC_URL);
    console.log("REG-SVC-WRKR.50: Load Event Handler  url=", swUrl);     // process.env.PUBLIC_URL);
    if (isLocalhost) {
        checkValidServiceWorker(swUrl);   // on localhost, check if a service worker exists
        navigator.serviceWorker.ready.then(() => {
            console.log( "REG-SVC-WRKR.35: LOCALHOST served cache-first from service worker https://goo.gl/SC7cgQ");
        });
    } else {
        console.log("REG-SVC-WRKR.46: Registering Service worker ....", swUrl);
        registerValidSW(swUrl); // Is not local host. Just register service worker
    }
}




// stale-while-revalidate
//
// chk: https://developers.google.com/web/updates/2017/02/navigation-preload  << preload (NOT USED)
// API: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/serviceWorker
function registerValidSW(swUrl) {
    console.log( "REG-SVC-WRKR.57:  MONITORING WORKER REGISTRATION @",swUrl);

    navigator.serviceWorker
    .register(swUrl)
    .then(reg => {
        reg.onupdatefound = () => {
            const worker = reg.installing;
            //INFO.service_worker = worker;
            worker.onstatechange = () => {
                if (worker.state === 'waiting') {
                    console.log("MON-SVC-WRKR.101: New svc-worker LOAD in WAITING MODE!");
                    window.dispatchEvent(INFO.version_event);      // alert user, svc worker got new version
                }

                if (worker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the old content will have been purged and
                        // the fresh content will have been added to the cache.
                        // It's the perfect time to display a "New content is
                        // available; please refresh." message in your web app.
                        console.log("MON-SVC-WRKR.57: New content is available; please refresh.");
                        //window.dispatchEvent(INFO.version_event);      // move it up to wait state

                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("MON-SVC-WRKR.62: Content is cached for offline use.");
                    }
                }
            };
        };
    })
    .catch(error => {
        console.error("MON-SVC-WRKR.69: Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl) {

    fetch(swUrl)   // check for service worker or can't reload page.
    .then(response => {
        if ( // verify service worker and this is js file.
            response.status === 404 ||
            response.headers.get("content-type").indexOf("javascript") === -1
        ) {
          navigator.serviceWorker.ready.then(registration => {
              registration.unregister().then(() => {
                  window.location.reload(); // no service worker, it may be diff app, reload
              });
          });
        } else {
            //console.log( "REG-SVC-WRKR.88:  Service worker ACTIVE for @",swUrl);
            registerValidSW(swUrl); // service worker found, continue
        }
    })
    .catch(() => {
        console.log( "REG-SVC-WRKR.90: No internet running in OFFLINE mode");
    });
}


export function unregisterServiceWorker() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister();
            console.log("REG-SVC-WRKR.98: UNREGISTERED!");
        });
    }
}
